module.exports = __webpack_public_path__ + "img/group-user-active.47913992.svg";